import React, { useState } from 'react';
import { logo } from '../assets';

export default function NewsletterPopup() {
    const [isOpen, setIsOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [msgType, setMsgType] = useState(''); // 'success' | 'exists' | 'error'

    const handleSubmit = (e) => {
        e.preventDefault();
        fetch('/forms/submit-newsletter/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
        })
            .then(res => res.json().then(data => ({ status: res.status, data })))
            .then(({ status, data }) => {
                if (status === 409) {
                    setMsgType('exists');
                    setMessage('This email is already subscribed!');
                } else if (data.success) {
                    setMsgType('success');
                    setMessage(data.success);
                    setEmail('');
                } else {
                    setMsgType('error');
                    setMessage(data.error || 'Something went wrong.');
                }
            })
            .catch(() => { setMsgType('error'); setMessage('Error submitting form'); });
    };

    return (
        <>
            {/* Floating button — bottom right */}
            <div
                className="fixed bottom-5 right-5 z-[900] cursor-pointer flex flex-col items-center group"
                onClick={() => setIsOpen(true)}
            >
                <div className="bg-red-600 rounded-full p-3 shadow-lg group-hover:bg-red-700 transition-colors flex items-center justify-center h-[56px] w-[56px]">
                    <img src={logo} alt="Mainlogix" className="h-8 w-8 object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
                </div>
                <span className="text-[11px] font-poppins font-semibold text-red-600 mt-1 bg-white px-2 py-0.5 rounded shadow whitespace-nowrap">
                    Newsletter
                </span>
            </div>

            {/* Modal */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60"
                    onClick={(e) => { if (e.target === e.currentTarget) setIsOpen(false); }}
                >
                    <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 relative">
                        <button
                            onClick={() => setIsOpen(false)}
                            className="absolute top-3 right-4 text-gray-400 hover:text-red-600 text-2xl font-bold leading-none"
                            aria-label="Close"
                        >
                            &times;
                        </button>

                        <div className="flex flex-col items-center mb-6">
                            <img src={logo} alt="Mainlogix" className="h-14 mb-3 object-contain" />
                            <h2 className="font-poppins text-xl font-bold text-gray-800">Subscribe to Our Newsletter</h2>
                            <p className="text-gray-500 text-sm mt-1 text-center leading-relaxed">
                                Stay updated with the latest IoT news and insights from Mainlogix.
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email..."
                                required
                                className="border border-gray-300 rounded-full px-5 py-2 text-sm focus:outline-none focus:border-red-600"
                            />
                            <button
                                type="submit"
                                className="bg-red-600 hover:bg-red-700 text-white rounded-full py-2 font-poppins font-semibold transition-colors"
                            >
                                SUBSCRIBE
                            </button>
                        </form>

                        {message && (
                            <p className={`text-center mt-3 text-sm font-medium ${msgType === 'success' ? 'text-green-600' : msgType === 'exists' ? 'text-yellow-600' : 'text-red-600'}`}>{message}</p>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
